<div class="ra-full-page-loading">
    <img class="rfpl-logo" src="/images/logo.png" alt="RapiDocs" />
    <div class="rfpl-spinner"></div>
    @if (message()) {
        <p class="rfpl-message ra-label-s">{{ message() }}</p>
    }
</div>
